import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-channel-inbox",
  "use": "app-channel-inbox-usage",
  "viewBox": "0 0 33 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 32\" id=\"app-channel-inbox\"><path d=\"M17.334 25v6m-12-20h22a4 4 0 014 4v9a1 1 0 01-1 1h-21m-4-14a4 4 0 014 4v10m-4-14a4 4 0 00-4 4v9a1 1 0 001 1h7m6-10V1m0 0h7a3 3 0 010 6h-7V1z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/app-channel-inbox.svg
// module id = io5S
// module chunks = 39 44